import React, { useContext, useRef, useCallback, ChangeEvent } from "react";
import addPhotoImage from "../../assets/icons/add-photo.svg";
import style from "./PhotoPicker.module.css";
import UserContext from "../../contexts/UserContext";
import ProfilePic from "../profilePic/ProfilePic";

type PhotoPickerProps = {
  size: number;
};

const PhotoPicker = ({ size }: PhotoPickerProps) => {
  const input = useRef<HTMLInputElement>(null!);

  // User Data
  const { state: userState, dispatch: dispatchUser } = useContext(UserContext);

  const openFilePicker = useCallback(() => {
    input.current.click();
  }, [input]);

  // TODO: Generate an image from the colour and layers.
  // Save as an image rather than having the browser process filters in realtime.
  const handleProfilePicChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.stopPropagation();

    const target = e.target as typeof e.target & {
      files: FileList;
    };

    // For Drag and drop dataTransfer is used. (e.dataTransfer && e.dataTransfer.files) || target.files
    const files = target.files;
    const file = files[0];

    if (!file) return;
    const reader = new FileReader();

    if (file.type.match(/image.*/)) {
      reader.readAsDataURL(file);
      reader.onload = (e: ProgressEvent) => {
        let img = new Image();

        const target = e.target as typeof e.target & {
          result: string;
        };

        img.src = target.result;

        img.onload = () => {
          const width = 800;
          const scaleFactor = width / img.width;
          let canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = img.height * scaleFactor;
          let ctx: CanvasRenderingContext2D | null = canvas.getContext("2d");
          if (ctx) {
            ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
            ctx.canvas.toBlob(
              (blob) => {
                // TODO: Save blob file
                // const newFile = new File([blob], "profilePic", {
                //   type: "image/jpeg",
                //   lastModified: Date.now(),
                // });
                dispatchUser({ type: "SET_PIC", data: target.result });
              },
              "image/jpeg",
              0.8
            );
          }
        };
      };
      reader.onerror = (error) => {
        console.log("Error with image:", error);
      };
    } else {
      window.alert("Please select an image file.");
    }
  };
  return (
    <div
      className={style.container}
      onClick={openFilePicker}
      style={{ width: size, height: size }}
    >
      <ProfilePic src={userState.pic} size={size} />
      {!userState.pic ? (
        <>
          <img src={addPhotoImage} alt="Smiley Face" />
          <label htmlFor="filePicker">Choose a photo of you smiling</label>
        </>
      ) : null}
      <input
        ref={input}
        className={style.fileInput}
        id="filePicker"
        name="files"
        type="file"
        accept="image/*"
        hidden={true}
        onChange={handleProfilePicChange}
        // data-testid="uploadFilePicker"
        // files={[pic]}
      />
    </div>
  );
};

PhotoPicker.propTypes = {};
PhotoPicker.defaultProps = {};

export default PhotoPicker;
